module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "doctors"
  }, [_c('md-card', [_c('md-card-header', [_c('div', {
    staticClass: "md-title"
  }, [_vm._v(_vm._s(_vm.$t("admin.doctors")))])])], 1), _vm._v(" "), _vm._l((_vm.doctors), function(doctor, index) {
    return _c('md-card', [_c('md-card-header', [_c('div', {
      staticClass: "md-title"
    }, [_vm._v(_vm._s(doctor.name))]), _vm._v(" "), _c('div', {
      staticClass: "md-subhead"
    }, [_vm._v(_vm._s(doctor.doctorData.speciality))])]), _vm._v(" "), _c('md-card-content', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-6 col-xs-12"
    }, [_c('b', [_vm._v("Páciensek száma:")]), _vm._v(" " + _vm._s(doctor.patientCount) + "\n\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "col-md-6 col-xs-12"
    }, [_c('b', [_vm._v("Bejelentkezési e-mail:")]), _vm._v(" " + _vm._s(doctor.email) + "\n\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "col-md-6 col-xs-12"
    }, [_c('b', [_vm._v("Adatbázis azonosító:")]), _vm._v(" " + _vm._s(doctor._id) + "\n\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12"
    }, [_c('b', [_vm._v("Bemutatkozás:")]), _c('br'), _vm._v("\n\t\t\t\t" + _vm._s(doctor.doctorData.introduction) + "\n\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 contentWrapper"
    }, [_c('h4', [_vm._v("Publikus kapcsolati adatok:")]), _vm._v(" "), _vm._l((doctor.doctorData.contact), function(contact) {
      return _c('div', [_c('b', [_vm._v(_vm._s(contact.name) + ":")]), _vm._v(" " + _vm._s(contact.value) + "\n\t\t\t\t\t")])
    })], 2), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 contentWrapper"
    }, [_c('h4', [_vm._v("Statisztikák:")]), _vm._v(" "), _vm._l((doctor.activity), function(activity) {
      return _c('div', [(activity.type == 'INID.activity.globalViewed') ? _c('div', [_c('b', [_vm._v("Legutolsó belépés:")]), _vm._v(" " + _vm._s(_vm.simpleDate(activity.events[activity.events.length - 1])) + "\n\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (activity.type == 'INID.activity.patientsViewed') ? _c('div', [_c('b', [_vm._v("Páciens lista megtekintve:")]), _vm._v(" " + _vm._s(_vm.simpleDate(activity.events[activity.events.length - 1])) + "\n\t\t\t\t\t")]) : _vm._e()])
    })], 2)])], 1)
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7732563c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/DoctorList.vue
// module id = 423
// module chunks = 2